import PermissionOverviewSubPage from "./permission-overview-sub-page";

const SubPage = {
    OverView: PermissionOverviewSubPage,
};

export default SubPage;